var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"row-content-wrapper-colored",class:_vm.wrapperClass,attrs:{"fluid":_vm.fluid}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticClass:"mx-auto px-2 content-container",attrs:{"cols":"12","md":"12"}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }